import React from 'react';
import s from './DashboardPage.module.css';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store/store';
import { getTrendingTopics, setContentType } from '../../store/slices/onboardingSlice';
import RecentProjects from './widgets/recent-projects/RecentProjects';
import { useSelector } from 'react-redux';
import {
    selectIsLoading,
    selectUser,
    selectFirstConnectedSocial,
} from '../../store/selectors/authSelectors';
import { selectPlan } from '../../store/selectors/subscriptionSelector';
import LoadingGeneration from '../../shared/ui/loading-generation/LoadingGeneration';
import {
    selectIsCreatingProject,
    selectSelectedSocialMedia,
} from '../../store/selectors/projectSelectors';
import UserProfileButton from '../../shared/ui/user-profile-button/UserProfileButton';
import Button from '../../shared/ui/button/Button';
import { useNavigate } from 'react-router-dom';
import DropDownMenu from '../../shared/ui/dropdown-menu/DropDownMenu';
import TodaysTrends from './widgets/TodaysTrends';
import AudienceInsights from './widgets/AudienceInsights';
import LatestComments from './widgets/latest-comments/LatestComments';
import UserDataDashboard from './widgets/user-data-dashboard/UserDataDashboard';
import Loader from '../../shared/ui/loader/Loader';
import { socialMediaOptions } from '../../shared/constant/constant';
import welcomeHand from '../../assets/img/wave.svg';
import { setSelectedSocialMedia } from '../../store/slices/projectSlice';
import TrialExpiredModal from '../setting-page/component/subscription/TrialExpiredModal';
import { SocialConnections } from '../../shared/types/authTypes';
import QuickPostModal from './widgets/quick-post-modal/QuickPostModal';
import IconLock from '../../shared/ui/icons/IconLock';
import { setPricingModal } from '../../store/slices/pageSlice';
import {
    selectIsBasicSubscription,
    selectIsFreeSubscription,
} from '../../store/selectors/subscriptionSelector';
import { getRecentProjects } from '../../shared/api/textProjectApi';
const DashboardPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const isLoading = useSelector(selectIsLoading);
    const isCreatingProject = useSelector(selectIsCreatingProject);
    const selectedSocialMedia = useSelector(selectSelectedSocialMedia);
    const user = useSelector(selectUser);
    const firstConnectedSocial = useSelector(selectFirstConnectedSocial);
    const userSocialConnections = user?.social_connections;
    const updatedSocialMediaOptions = socialMediaOptions.map((option) => ({
        ...option,
        disabled: !userSocialConnections?.[option.value as keyof SocialConnections],
    }));

    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);
    const [isQuickPostModalOpen, setIsQuickPostModalOpen] = useState(false);

    const isDisabledQuickPost = selectedSocialMedia == null;

    useEffect(() => {
        dispatch(setContentType(''));
        dispatch(getTrendingTopics('TodaysTrend'));
    }, [dispatch]);

    useEffect(() => {
        if (user?.id) {
            dispatch(getRecentProjects(user.id));
        }
    }, [user?.id]);

    if (isLoading) {
        return <Loader />;
    }

    const handleQuickPost = () => {
        if (isFreeSubscription || isBasicSubscription) {
            dispatch(setPricingModal(true));
        } else {
            if (
                selectedSocialMedia != 'pinterest' &&
                selectedSocialMedia != 'facebook' &&
                selectedSocialMedia != 'linkedin'
            ) {
                navigate(`/generate-quick-post/${selectedSocialMedia}?source=dashboard`);
            } else {
                setIsQuickPostModalOpen(true);
            }
        }
    };

    return (
        <div className={s.container}>
            <div className={s.header}>
                <h3 className={s.header_title}>
                    Welcome back, {user?.name || user?.username || user?.email}!{' '}
                    <img src={welcomeHand} alt="welcome hand" />
                </h3>
                <div className={s.header_actions}>
                    <UserProfileButton />
                </div>
            </div>

            <div className={s.top_content}>
                <div className={s.left_content}>
                    <UserDataDashboard selectedSocialMedia={selectedSocialMedia} />
                    <RecentProjects />
                </div>
                <div className={s.right_content}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div className={s.right_component_group}>
                            <span className={s.right_text}>Choose platform</span>
                            <div style={{ width: '100%', marginTop: '-26px' }}>
                                <DropDownMenu
                                    width={250}
                                    options={updatedSocialMediaOptions}
                                    selectedOption={selectedSocialMedia}
                                    setSelectedOption={(option) => {
                                        dispatch(setSelectedSocialMedia(option));
                                    }}
                                />
                            </div>

                            <Button
                                text="Quick post"
                                icon={
                                    isFreeSubscription || isBasicSubscription ? (
                                        <IconLock color="#fff" />
                                    ) : undefined
                                }
                                onClick={handleQuickPost}
                                style={{
                                    background: 'linear-gradient(90deg, #8801FF 0%, #D400FF 100%)',
                                    color: '#ffffff',
                                    fontFamily: 'Figtree',
                                    fontWeight: 400,
                                    fontStyle: 'SemiBold',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    letterSpacing: '0%',
                                    verticalAlign: 'middle',
                                }}
                                state={isDisabledQuickPost ? 'disabled' : 'enabled'}
                            />
                        </div>

                        <div className={s.right_component_group}>
                            <LatestComments />
                        </div>

                        <div className={s.right_component_group}>
                            <p className={s.right_title}>Today's new trends</p>
                            <TodaysTrends />
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.bottom_content}>
                <AudienceInsights
                    userSocialConnections={userSocialConnections || ({} as SocialConnections)}
                    selectedSocialMedia={selectedSocialMedia}
                />
            </div>

            {isCreatingProject && <LoadingGeneration />}
            <TrialExpiredModal />
            <QuickPostModal
                isOpen={isQuickPostModalOpen}
                onClose={() => setIsQuickPostModalOpen(false)}
                selectedSocialMedia={selectedSocialMedia || ''}
            />
        </div>
    );
};

export default DashboardPage;
